export const Constants = {
  baseUrl: "https://apipershia.khaneman.click/api/app",
  imageUrl: "https://apipershia.khaneman.click/",
};
